// extracted by mini-css-extract-plugin
export default {"component":"page-title_component__S-iA7","btn":"page-title_btn__v3kuK"};